import Vue from 'vue'
import Router from 'vue-router'
import {
  MS_AUTHORITY_HEADQUARTERS,
  MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT,
  MS_AUTHORITY_HEAD_OF_BRANCH,
  MS_AUTHORITY_HEAD_OF_DEPARTMENT
} from '../config/index'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/screens/home/index'),
      meta: {auth: true, title: 'SNS'}
    },
    {
      path: '/institutions/search',
      name: 'institutions.search',
      component: () => import('@/screens/institutions/search'),
      meta: {auth: true}
    },
    {
      path: '/institutions/:institutionCode',
      name: 'institutions.show',
      component: () => import('@/screens/institutions/show'),
      meta: {auth: true}
    },
    {
      path: '/chat-groups/:chatGroupId/chat',
      name: 'chat',
      component: () => import('@/screens/chat'),
      meta: {auth: true}
    },
    {
      path: '/fine-plays',
      name: 'finePlays',
      component: () => import('@/screens/fine-plays'),
      meta: {auth: true}
    },
    {
      path: '/fine-plays/:finePlayId',
      name: 'finePlays.show',
      component: () => import('@/screens/fine-plays/show'),
      meta: {auth: true}
    },
    {
      path: '/fine-plays-approve',
      name: 'finePlayApproves',
      component: () => import('@/screens/fine-plays-approve'),
      meta: {auth: [
        MS_AUTHORITY_HEAD_OF_DEPARTMENT,
        MS_AUTHORITY_HEAD_OF_BRANCH,
        MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT,
        MS_AUTHORITY_HEADQUARTERS
      ]}
    },
    {
      path: '/fine-plays-approve/:finePlayId',
      name: 'finePlayApproves.show',
      component: () => import('@/screens/fine-plays-approve/show'),
      meta: {auth: [
        MS_AUTHORITY_HEAD_OF_DEPARTMENT,
        MS_AUTHORITY_HEAD_OF_BRANCH,
        MS_AUTHORITY_HEAD_OF_SALES_DEPARTMENT,
        MS_AUTHORITY_HEADQUARTERS
      ]}
    },
    {
      path: '/shares',
      name: 'shares',
      component: () => import('@/screens/shares'),
      meta: {auth: true}
    },
    {
      path: '/shares/:institutionCode',
      name: 'shares.show',
      component: () => import('@/screens/shares/show'),
      meta: {auth: true}
    },
    {
      path: '/shares/:chatGroupId/chat/:messageId',
      name: 'shares.chat',
      component: () => import('@/screens/shares/chat'),
      meta: {auth: true}
    },
    {
      path: '/bookmarks/:chatGroupId/:messageId',
      name: 'bookmarks.show',
      component: () => import('@/screens/bookmarks/show'),
      meta: {auth: true}
    },
    {
      path: '/surveys',
      name: 'surveys.index',
      component: () => import('@/screens/surveys/index'),
      meta: {auth: true}
    },
    {
      path: '/surveys/:id',
      name: 'surveys.show',
      component: () => import('@/screens/surveys/show'),
      meta: {auth: true}
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/screens/auth/login'),
      meta: {auth: false}
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/screens/auth/forgot-password'),
      meta: {auth: false}
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: () => import('@/screens/auth/reset-password'),
      meta: {auth: false}
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/screens/profile/index'),
      meta: {auth: true, title: '設定'}
    },
    {
      path: '/term-of-use',
      name: 'term-of-use',
      component: () => import('@/screens/static-pages/term-of-use'),
      meta: {auth: false}
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/screens/errors/403'),
      meta: {title: '403'}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js